/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../SharedModules/services/service';
import {
  resetCodeTableStore,
  setCodeTableDataLoading,
} from '../../System/codeTables/store/actions';
import {
  ERR_PROCESSING_REQ,
  SAVE_SUCCESS,
} from '../../../SharedModules/AppConstants';
import { resetPriceTypeStore } from '../../System/priceType/store/action';
import {
  resetSelectClaimData,
  resetSelectedClaimData,
} from '../../Display/Claim/store/action';
import {
  resetNDCData,
  resetNDCDetailsData,
} from '../../Display/NDC/store/action';
import { resetDeleteCheckLogStore } from '../../System/TechnicalWindow/OnlineFixes/DeleteCheckLog/store/action';
import { resetDeleteBatchStore } from '../../System/TechnicalWindow/OnlineFixes/RequestDeleteBatch/store/action';
import { resetFreezeInvoiceStore } from '../../Invoice/FreezeInvoice/Store/actions';
import { resetMatDrugStore } from '../../CMS/MaintainMATDrug/store/actions';
import { resetRequestInvoiceCalculationStore } from '../../Invoice/RequestInvoiceCalculation/Store/actions';
import { resetReqURLCalcStore } from '../../Invoice/RequestURACalculation/Store/actions';
import { resetCreateUtilizationTapStore } from '../../Invoice/CreateUtilizationTape/Store/actions';
import { resetUnfreezeInvoiceStore } from '../../System/TechnicalWindow/OnlineFixes/UnfreezeInvoice/Store/actions';
import { resetRemoveSuspendedDateStore } from '../../System/TechnicalWindow/OnlineFixes/RemoveSuspendedDt/Store/actions';
import { resetRecordMailingDateStore } from '../../Invoice/RecordMailingDate/Store/actions';
import { resetStubInvoiceStore } from '../../System/TechnicalWindow/OnlineFixes/CreateStubInvoice/store/action';
import { resetPeriodicReportStore } from '../../System/TechnicalWindow/PeriodicReport/store/actions';
import { resetDisplayInvoiceStore } from '../../Display/invoice/store/actions';
import { resetTransitionDataStore } from '../../System/TechnicalWindow/TransitionData/store/action';
import { resetSystemParameterStore } from '../../System/systemParameter/store/actions';
import { resetIneligibleProviderStore } from '../../Maintain/IneligibleProviders/Store/actions';
import { resetQuarterlyMarketingStore } from '../../System/TechnicalWindow/QuarterlyMarketingData/store/action';
import { resetCGPDetailStore } from '../../System/claimGroupingParameter/store/actions';
import { resetDisplayInvoiceReportStore } from '../../Display/InvoiceReport/store/actions';

export const dispatchGetContactTypeDetails = (data) => ({
  type: actionTypes.GET_CONTACT_TYPE_DETAILS,
  contactTypeResults: data,
});

export const dispatchUpdateContactTypeDetails = (data) => ({
  type: actionTypes.UPDATE_CONTACT_TYPE_DETAILS,
  updateContactDetails: data,
});

export const getContactTypeDetails = () => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_CONTACT_TYPE_DETAILS)
    .then((response) => {
      dispatch(dispatchGetContactTypeDetails(response.data));
    })
    .catch((error) => {
      dispatch(dispatchGetContactTypeDetails({ error: 'API failed' }));
    });
};

export const updateContactTypeDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_CONTACT_TYPE_DETAILS, values)
    .then((response) => {
      dispatch(dispatchUpdateContactTypeDetails(response.data));
      dispatch(getContactTypeDetails());
    })
    .catch((error) => {
      dispatch(getContactTypeDetails());
    });
};

export const resetSaveFlag = (data) => {
  return (dispatch) => {
    dispatch(dispatchResetSaveFlag());
  };
};

export const dispatchResetSaveFlag = () => ({
  type: actionTypes.RESET_SAVE_FLAG,
  value: false,
});

export const setCompareContactTypeData = (payload) => {
  return {
    type: actionTypes.COMPARE_CONTACT_TYPE_DATA,
    payload,
  };
};

export const setContactTypeDataLoading = (payload) => {
  return {
    type: actionTypes.CONTACT_TYPE_DETAILS_LOADING,
    payload,
  };
};

export const setContactTypeDataRowSelected = (payload) => {
  return {
    type: actionTypes.CONTACT_TYPE_ROW_SELECTED,
    payload,
  };
};

export const setContactTypeErrorMessage = (payload) => {
  return {
    type: actionTypes.CONTACT_TYPE_DETAILS_ERROR_MESSAGE,
    payload,
  };
};
export const setChildContactTypeError = (payload) => {
  return {
    type: actionTypes.CHILD_CONTACT_TYPE_ERROR,
    payload,
  };
};

export const setContactTypeSuccessMessage = (payload) => {
  return {
    type: actionTypes.CONTACT_TYPE_DETAILS_SUCCESS_MESSAGE,
    payload,
  };
};

export const setContactTypeDataNew = (payload) => {
  return {
    type: actionTypes.GET_CONTACT_TYPE_DETAILS_NEW,
    payload,
  };
};

export const setContactTypeDataChangeTried = (payload) => {
  return {
    type: actionTypes.CONTACT_TYPE_DETAILS_DATA_CHANGE_TRIED,
    payload,
  };
};

export const resetContactTypeStore = () => {
  return {
    type: actionTypes.RESET_CONTACT_TYPE_STORE,
  };
};

export const resetReduxStore = (navTo) => {
  return (dispatch) => {
    if (navTo === '/claim') {
      dispatch(resetSelectClaimData());
    } else if (navTo === '/selected-claim') {
      dispatch(resetSelectedClaimData());
    } else if (navTo === '/ndc') {
      dispatch(resetNDCData());
    } else if (navTo === '/ndc-details') {
      dispatch(resetNDCDetailsData());
    } else if (navTo === '/contactType') {
      dispatch(resetContactTypeStore());
    } else if (navTo === '/codeTable') {
      dispatch(resetCodeTableStore());
    } else if (navTo === '/priceType') {
      dispatch(resetPriceTypeStore());
    } else if (navTo === '/deleteCheckLog') {
      dispatch(resetDeleteCheckLogStore());
    } else if (navTo === '/requestdeletebatch') {
      dispatch(resetDeleteBatchStore());
    } else if (navTo === '/freezeInvoice') {
      dispatch(resetFreezeInvoiceStore());
    } else if (navTo === '/MaintainCMSMatDrugs') {
      dispatch(resetMatDrugStore());
    } else if (navTo === '/requestInvoiceCalculation') {
      dispatch(resetRequestInvoiceCalculationStore());
    } else if (navTo === '/RequestURACalculation') {
      dispatch(resetReqURLCalcStore());
    } else if (navTo === '/createUtilizationTape') {
      dispatch(resetCreateUtilizationTapStore());
    } else if (navTo === '/unfreezeInvoice') {
      dispatch(resetUnfreezeInvoiceStore());
    } else if (navTo === '/removeSuspendedDt') {
      dispatch(resetRemoveSuspendedDateStore());
    } else if (navTo === '/recordMailingDate') {
      dispatch(resetRecordMailingDateStore());
    } else if (navTo === '/createStubInvoice') {
      dispatch(resetStubInvoiceStore());
    } else if (navTo === '/periodicBalanceRpt') {
      dispatch(resetPeriodicReportStore());
    } else if (navTo === '/request-invoice-detail') {
      dispatch(resetDisplayInvoiceStore());
    } else if (navTo === '/request-invoice-report') {
      dispatch(resetDisplayInvoiceReportStore());
    } else if (navTo === '/transitionData') {
      dispatch(resetTransitionDataStore());
    } else if (navTo === '/systemparameter') {
      dispatch(resetSystemParameterStore());
    } else if (navTo === '/ineligibleProviders') {
      dispatch(resetIneligibleProviderStore());
    } else if (navTo === '/quarterlyMarketingData') {
      dispatch(resetQuarterlyMarketingStore());
    } else if (navTo === '/claimGroupingParameterDetail') {
      dispatch(resetCGPDetailStore());
    }
  };
};

export const callGetContactTypeDetailsAPI = async () => {
  try {
    const response = await axios.get(serviceEndPoint.GET_CONTACT_TYPE_DETAILS);

    if (response.data && response.data.object) {
      return response.data.object;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const updateContactTypeAPI = async (values) => {
  try {
    await axios.post(serviceEndPoint.UPDATE_CONTACT_TYPE_DETAILS, values);

    return 'Success';
  } catch (e) {
    return null;
  }
};

export const updateAndGetContactTypeDetails = (values, func) => {
  return async (dispatch) => {
    const response = await updateContactTypeAPI(values);
    if (response) {
      dispatch(
        getAndDispatchContactDetails(() => {
          if (func) {
            func();
          }

          dispatch(setContactTypeSuccessMessage(SAVE_SUCCESS));
        })
      );
    } else {
      dispatch(setContactTypeSuccessMessage(''));
      dispatch(setContactTypeErrorMessage(ERR_PROCESSING_REQ));
    }
  };
};

export const DummyUpdateAndDelete = () => {
  return (dispatch, getState) => {
    let currentData = [
      ...getState().sharedState.ContactTypeReducer.newContactTypeResult,
    ];

    currentData.push({});
    currentData[0].contactTypeCdVO = [...currentData[0].contactTypeCdVO, {}];
    dispatch(setContactTypeDataNew(currentData));
    dispatch(setContactTypeDataRowSelected(currentData[0]));

    currentData = currentData.filter((item) => item.codeValueVO);
    currentData[0].contactTypeCdVO = currentData[0].contactTypeCdVO.filter(
      (item) => item.keyTypeCd
    );

    dispatch(setContactTypeDataNew(currentData));
    dispatch(setContactTypeDataRowSelected(currentData[0]));
  };
};

export const getAndDispatchContactDetails = (func) => {
  return async (dispatch) => {
    dispatch(setContactTypeDataLoading(true));
    const response = await callGetContactTypeDetailsAPI({});
    if (response) {
      const newResponse = response.map((item) => {
        return {
          ...item,
          contactTypeCdVO: item.contactTypeCdVO.map((innerItem, innerIndex) => {
            return { ...innerItem, index: innerIndex };
          }),
        };
      });

      dispatch(setContactTypeDataNew(newResponse));
      dispatch(setCompareContactTypeData(_.cloneDeep(newResponse)));
      dispatch(setContactTypeDataRowSelected(newResponse[0]));
      dispatch(DummyUpdateAndDelete());
      dispatch(setContactTypeErrorMessage(''));
    } else {
      dispatch(setContactTypeDataNew([]));
      dispatch(setCompareContactTypeData([]));
      dispatch(setContactTypeDataRowSelected(null));
      dispatch(setContactTypeErrorMessage(ERR_PROCESSING_REQ));
    }

    if (func) {
      func();
    } else {
      dispatch(setContactTypeSuccessMessage(''));
    }

    dispatch(setContactTypeDataLoading(false));
  };
};

export const addContactTypeRow = (row, logInUser) => {
  return (dispatch, getState) => {
    const currentData = [
      ...getState().sharedState.ContactTypeReducer.newContactTypeResult,
    ];

    if (currentData.length > 0) {
      const index = currentData.findIndex(
        (item) => item.codeValueVO.codeValue === row.codeValueVO.codeValue
      );

      if (index !== -1) {
        currentData[index].contactTypeCdVO = [
          {
            contactTypeCd: '',
            keyTypeCd: row.codeValueVO.codeValue,
            shortDescr: '',
            longDescr: '',
            dispSeq: null,
            index:
              (currentData[index].contactTypeCdVO &&
                currentData[index].contactTypeCdVO.length) ||
              0,
            lastUpdateDt: null,
            lastUpdateUserId: logInUser,
            isNewRecord: true,
          },
          ...currentData[index].contactTypeCdVO,
        ];

        dispatch(setContactTypeDataNew(currentData));
        dispatch(setContactTypeDataRowSelected(currentData[index]));
      }
    } else {
    }
  };
};

export const deleteContactTypeRow = (row, logInUser) => {
  return (dispatch, getState) => {
    dispatch(setCodeTableDataLoading(true));
    const currentData = [
      ...getState().sharedState.ContactTypeReducer.newContactTypeResult,
    ];

    if (currentData.length > 0) {
      const index = currentData.findIndex(
        (item) => item.codeValueVO.codeValue === row.keyTypeCd
      );

      if (index !== -1) {
        let updatedValue = [];
        if (row.isNewRecord) {
          updatedValue = currentData[index].contactTypeCdVO.filter(
            (item, itemIndex) => item.index !== row.index
          );
        } else {
          updatedValue = currentData[index].contactTypeCdVO.map((item) => {
            if (item.index === row.index && !item.isNewRecord) {
              return {
                ...item,
                deleteFlag: true,
                lastUpdateUserId: logInUser,
              };
            }
            return { ...item };
          });
        }

        currentData[index].contactTypeCdVO = updatedValue;

        dispatch(setContactTypeDataNew(currentData));
        dispatch(setContactTypeDataRowSelected(currentData[index]));
      }
    } else {
    }
    dispatch(setCodeTableDataLoading(false));
  };
};

export const checkDeleteRowPossible = async (data) => {
  try {
    const values = {
      keyTypeCd: data.keyTypeCd,
      contactTypeCd: data.contactTypeCd,
    };

    const response = await axios.post(
      serviceEndPoint.VALIDATE_CONTACT_TYPE,
      values
    );

    if (response.data && response.data.code === '002') {
      return 'Success';
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const updateParentUserId = (parentIndex, userId) => {
  return (dispatch, getState) => {
    const currentData = [
      ...getState().sharedState.ContactTypeReducer.newContactTypeResult,
    ];

    currentData[parentIndex].codeValueVO.lastUpdateUserId = userId;

    dispatch(setContactTypeDataNew(currentData));
    dispatch(setContactTypeDataRowSelected(currentData[parentIndex]));
  };
};

export const updateChildUserId = (parentIndex, childIndex, userId) => {
  return (dispatch, getState) => {
    const currentData = [
      ...getState().sharedState.ContactTypeReducer.newContactTypeResult,
    ];

    currentData[parentIndex].contactTypeCdVO[childIndex].lastUpdateUserId =
      userId;
    dispatch(setContactTypeDataNew(currentData));
    dispatch(setContactTypeDataRowSelected(currentData[parentIndex]));
  };
};
